import React from "react";

function VisitCardSkeleton() {
  return (
    <div className="rounded-2xl border border-neutral-200/80 bg-card p-4 shadow-[0_2px_8px_-2px_rgba(0,0,0,0.06)]">
      <div className="mb-3">
        <div className="h-5 w-full max-w-xl rounded bg-neutral-200" />
        <div className="mt-2 flex flex-wrap items-center gap-2">
          <div className="h-5 w-[4.5rem] rounded bg-neutral-200" />
          <div className="h-3 w-40 rounded bg-neutral-100" />
          <div className="h-1 w-1 rounded-full bg-neutral-200" />
          <div className="h-3 w-24 rounded bg-neutral-100" />
        </div>
      </div>
      <div className="space-y-2">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="rounded-lg border border-neutral-100 bg-neutral-50/30 px-3 py-2">
            <div className="mb-2 h-2.5 w-28 rounded bg-neutral-200" />
            <div className="space-y-1.5">
              <div className="h-2 w-full rounded bg-neutral-100" />
              <div className="h-2 w-[94%] rounded bg-neutral-100" />
              <div className="h-2 w-[78%] rounded bg-neutral-100" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export const SkeletonView: React.FC = () => (
  <div className="w-full animate-pulse space-y-4 pt-2">
    <div className="mb-4 flex min-w-0 items-center gap-3">
      <div className="h-7 w-36 rounded-lg bg-neutral-200" />
      <div className="h-7 w-28 rounded-lg bg-neutral-100" />
    </div>
    <div className="space-y-3">
      {[1, 2, 3].map((i) => (
        <VisitCardSkeleton key={i} />
      ))}
    </div>
  </div>
);
